export default "__VITE_ASSET__D42t8vwV__"